import { CxEvent } from '@spartacus/core';

export class Ga4GgSearchViewAutoCompleteResultsEvent extends CxEvent {
  event?: string;
}
